import React from 'react';
import { useStateContext } from '../../../../context/ContextProvider';
import ColorLandingPage from '../../../LandingPages/ColorLandingPage';

function AziziFlorence({
    language
}) {
    const color = "cyan";

    const poster = "/assets/images/projects/azizi-florence/azizi-florence.png";
    // const images = [
    //     "/assets/images/projects/azizi-venice/1.webp",
    //     "/assets/images/projects/azizi-venice/2.webp",
    //     "/assets/images/projects/azizi-venice/3.webp",
    //     "/assets/images/projects/azizi-venice/4.webp"
    // ];

    // const poster = "/assets/images/projects/azizi-venice/poster.jpg";
    // const webm = "/assets/images/projects/azizi-venice/hero.webm";
    const video = "/assets/images/projects/azizi-venice/azizi-venice.mp4";

    const {
        langs,
        langCode,
        userInfo,
        HIKALRE_URL,
    } = useStateContext();

    const currentLang = langs.find((lang) => lang.code === langCode);

    const isUAE = userInfo?.countryName == "United Arab Emirates";
    const isUSA = userInfo?.countryName == "United States";
    const isCanada = userInfo?.countryName == "Canada";

    const Heading = () => {
        return (
            <>
                {language == "ar" ? (
                    <h1 className="text-center text-xl lg:text-2xl font-bold leading-relaxed">
                        <span className="text-2xl text-cyan-200 neon-cyan">
                            فرصتك قبل الطرح
                        </span>
                        <br />
                        سجل الحين وهنرسلك التفاصيل
                        {/* <span className="text-2xl text-cyan-200 neon-cyan">
                            وفر أكثر من 77 ألف درهم.. وامتلك شقتك دقائق من مطار آل مكتوم
                        </span>
                        <br /> */}
                    </h1>
                ) : (
                    <h1 className="font-bold text-center text-xl leading-relaxed">
                        <span className="text-2xl text-cyan-200 neon-cyan">
                            Your opportunity before the launch
                        </span>
                        <br />
                        Register now and we'll send you the details
                    </h1>
                )}

            </>
        );
    }

    const gridDetails = [
        {
            "topic": "أنواع الوحدات",
            "text": "استوديو 3,2,1 غرفة",
        },
        {
            "topic": "الأسعار تبدأ من",
            "text": isUAE ? "655,000 درهم" : "180 ألف دولار",
        },
        {
            "topic": "أقساط شهرية",
            "text": isUAE ? "6600 درهم" : "1800 دولار",
        },
    ];

    const imageDetails = {
        "title": "✨ عرض حصري لفترة محدودة ✨",
        "desc": "احجز وحدتك الآن واستمتع بمطبخ مجهز بالكامل بجميع الأجهزة الكهربائية من ماركة Siemens الألمانية"
    };

    return (
        <>
            <ColorLandingPage
                color={color}
                // language={language}
                langToggle={{
                    en: "/azizi/florence",
                    ar: "/azizi/florence/ar",
                }}
                poster={poster}
                // video={video}
                // images={images}
                heading={<Heading />}
                // gridDetails={gridDetails}
                // imageDetails={imageDetails}
                displayAmenity={false}
                displayVisa={false}
                base_url={HIKALRE_URL}
                projectName={"Florence"}
                developer="Azizi"
                project="Florence"
                leadType="Villa"
                language={language === "ar" ? "Arabic" : "English"}
                // enquiries={language == "ar" ? ["تاون هاوس 4 غرف", "ڤيلا 3 غرف", "ڤيلا 4 غرف", "ڤيلا 5 غرف"] : ["4-Bedroom Townhouse", "3-Bedroom Villa", "4-Bedroom Villa", "5-Bedroom Villa"]}
                enquiries={
                    language == "ar"
                        ? [
                            { label: "تاون هاوس 4 غرف", enquiryType: "4 Bedrooms", leadType: "Townhouse" },
                            { label: "ڤيلا 3 غرف", enquiryType: "3 Bedrooms", leadType: "Villa" },
                            { label: "ڤيلا 4 غرف", enquiryType: "4 Bedrooms", leadType: "Villa" },
                            { label: "ڤيلا 5 غرف", enquiryType: "5 Bedrooms", leadType: "Villa" },
                        ]
                        : [
                            { label: "4-Bedroom Townhouse", enquiryType: "4 Bedrooms", leadType: "Townhouse" },
                            { label: "3-Bedroom Villa", enquiryType: "3 Bedrooms", leadType: "Villa" },
                            { label: "4-Bedroom Villa", enquiryType: "4 Bedrooms", leadType: "Villa" },
                            { label: "5-Bedroom Villa", enquiryType: "5 Bedrooms", leadType: "Villa" },
                        ]
                }
                // assignedToManager={language == "fa" ? 120 : null}
                // assignedToSales={language == "fa" ? 518 : null}
                contactTime={isUSA || isCanada ? true : false}
                otpCode={101}
            />
        </>
    );
}

export default AziziFlorence;
